// import { getAppInsights } from '@/vendors/application-insights';

export function exceptionHandler (event) {
  let exception;
  if (typeof event === 'string') {
    exception = new Error(event);
  } else if (event instanceof PromiseRejectionEvent) {
    exception = event.reason;
  } else if (event instanceof Error) {
    exception = event;
  }
  // const appInsights = getAppInsights();
  // if (appInsights) {
  //   appInsights.trackException({ exception });
  // }
}
